export default __webpack_public_path__ + "static/bridgette_wells-b615c84fd8ead1da8de769a74e24a800.png";